module.exports = __webpack_public_path__ + "static/media/lvl1.9e466e1f.png";